// --- Action Types (should match cabana saga) ---
const PROCESS_CABANA_STEP = 'PROCESS_CABANA_STEP'; // Listed for completeness
const CABANA_STEP_PENDING = 'CABANA_STEP_PENDING';
const CABANA_STEP_SUCCESS = 'CABANA_STEP_SUCCESS';
const CABANA_STEP_FAILURE = 'CABANA_STEP_FAILURE';
const RESET_CABANA_STEP_STATE = 'RESET_CABANA_STEP_STATE'; // Optional reset action
const RESET_CABANA_UUID = 'RESET_CABANA_UUID';

const initialState = {
	loading: false,
	error: null,
	success: false,
	currentTransitionKey: null,
	lastCabanaUuid: null,
	results: [],
};

const cabanaWorkflowReducer = (state = initialState, action) => {
	switch (action.type) {
		case CABANA_STEP_PENDING:
			return {
				...state,
				loading: true,
				error: null,
				success: false,
				currentTransitionKey: action.payload.transitionKey,
				results: [],
			};
		case CABANA_STEP_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				success: true,
				lastCabanaUuid: action.payload.newCabanaUuid || state.lastCabanaUuid,
				results: action.payload.results || [],
			};
		case CABANA_STEP_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload.error || 'An unknown error occurred.',
				success: false,
				results: action.payload.results || [],
			};
		case RESET_CABANA_STEP_STATE:
			return {
				...state,
				loading: false,
				error: null,
				success: false,
				currentTransitionKey: null,
				results: [],
			};
		case RESET_CABANA_UUID:
			return {
				lastCabanaUuid: '',
				loading: false,
				error: null,
				success: false,
				currentTransitionKey: null,
				results: [],
			};
		default:
			return state;
	}
};

export default cabanaWorkflowReducer;
